export default "__VITE_ASSET__8vsc114x__"